import styles from './Certification.module.css';

import { useState } from "react";

import { certifyPatroller, decertifyPatroller } from "../../api.js";
import { useAuth } from "../../AuthContext"

import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import { Badge } from '../Badge/Badge';

export const Certification = ({ certification, patroller, onCertify }) => {
    const [ loading, setLoading ] = useState(false);
    const [ error, setError ] = useState(null);

    const { token } = useAuth();

    const certified = patroller.certifications?.find(c => c.id === certification.id);

    const handleCertify = async () => {
        if (loading) return; // Prevent multiple clicks

        setLoading(true);
        setError(null);

        // Optimistic update: update UI immediately
        const newCertified = !certified;
        onCertify(patroller.id, certification, newCertified);

        try {
            let result;

            if (certified) {
                result = await decertifyPatroller(patroller, certification, token);
            } else {
                result = await certifyPatroller(patroller, certification, token);
            }

            if (result !== true) {
                // Revert on failure
                onCertify(patroller.id, certification, !!certified);
                setError(result || `Failed to ${certified ? 'decertify' : 'certify'}`);
            }
        } catch (e) {
            // Revert on error
            onCertify(patroller.id, certification, !!certified);
            setError(e.message || 'An error occurred');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={ `${ styles.badge } ${ !certified && styles.disabled }` } onClick={ handleCertify } style={{ position: 'relative' }}>
            {loading ? (
                <CircularProgress size={24} style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
            ) : (
                <Badge certification={certification} certified={certified} loading={loading} />
            )}

            {error && <Typography variant="caption" color="error" style={{ fontSize: '0.7rem', marginTop: '4px' }}>{error}</Typography>}
        </div>
    );
};